let home = {
  systemMsg: 'System Message',
  link: 'Referral Links',
  editPwd: 'Modify Password',
  withDraw: 'Withdraw',
  withDrawCheck: 'Withdraw Audit',
  staticReport: 'Statistical Report',
  rebateHistory: 'Rebate History',
  transferCheck: 'Transfer Audit',
  transferApply: 'Transfer Apply',
  logout: 'Log Out',
  oldPwd: 'Original Password',
  addMsg: 'Add Message',
  title: 'Title',
  content: 'Content',
  hint: 'Hint',
  confirmDel: 'Determine To Delete This Information?',
  deleted: 'Has Been deleted',
  cancleDel: 'Has Been Cancelled',
  msgSuccess: 'Messaging success',
  oldPwdError: 'Original password is error',
  loginAgain: 'Modify Password successed,please login again!',
  noData: 'No Data',
  /* 出金申请 */
  holderName: 'Account holder name',
  enterHolderName: 'Enter Account Holder Name',
  accountNumber: 'Account Number',
  enterAccountNumber: 'Enter Account Number',
  currency: 'Currency',
  selectCurrency: 'Select Currency',
  amount: 'Amount',
  enterAmount: 'Enter Amount',
  balance: 'Account Balance',
  charge: 'Charge',
  enterCharge: 'Enter Charge',
  payeeName: 'payee Name',
  enterPayeeName: 'Enter Payee Name',
  bankName: 'Bank Name',
  enterBankName: 'Enter Bank Name',
  province: 'Province',
  enterPorvince: 'Enter Porvince',
  city: 'City',
  enterCity: 'Enter City',
  bankBranch: 'Bank Branch',
  enterBankBranch: 'Enter Bank Branch',
  bankAccount: 'Bank Account',
  enterBankAccount: 'Enter Bank Account',
  bankSwift: 'Bank SWIFT',
  enterBankSwift: 'Enter Bank SWIFT',
  bankIban: 'Bank IBAN',
  enterBankIban: 'Enter Bank IBAN',
  sortCode: 'Sort Code',
  enterSortCode: 'Enter Sort Code',
  setDefaultWithdraw: 'Set Default Withdraw',
  reset: 'Reset',
  submit: 'Submit',
  ApplicationInfo: 'Application Information',
  selectAppStatus: 'Select Status',
  inHand: 'pending',
  figureOut: 'completed',
  rejected: 'rejected',
  canceled: 'Cancelled',
  status: 'Status',
  regDate: 'Application Date',
  confimApp: 'Application for confirmation',
  rufuseApp: 'Rejected application',
  noBalance: 'Lack of balance',
  unfinished: 'You have an outstanding application',
  withdrawSuccess: 'Withdraw Success',
  addCnName: 'Please send mail to customer service department to add name',
  enterRefuseReason: 'Please Enter Refuse Reason',
  /* 转账申请 */
  transferAmount: 'Transfer amount',
  enterTransfer: 'Enter Transfer Amount',
  comment: 'Comment',
  enterComment: 'Enter Comment',
  rollinAccount: 'Transfer to Account',
  enterRollinAccount: 'Enter Transfer to Account',
  enterCorrectRollin: 'Enter Correct Account',
  updateReason: 'Update Reason'
}

export default home;


// WEBPACK FOOTER //
// ./src/i18n/english/home.js